import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import API from 'api'
import Modal from 'react-modal'
import { Form } from 'react-final-form'
import { FormInput, FormTextArea } from '../../forms/final-form-fields'
import { toast } from 'react-toastify'
import { addingReport } from './validations'

const messages = defineMessages({
  placeholder: {
    id: 'reviews.dive_site.provide_information',
    defaultMessage: 'Provide us information about this review',
  },
  reportSent: {
    id: 'reviews.dive_site.report_sent',
    defaultMessage: 'Your report has been sent',
  },
  email: {
    id: 'your_email',
    defaultMessage: 'Your email',
  },
  report: {
    id: 'reviews.dive_site.report_issue',
    defaultMessage: 'Reason for reporting',
  },
})

const ReviewReportModal = ({ intl, reviewId, isOpen, closeModal }) => {
  const handleReportSubmit = (data) => {
    API(`dive-guide/adventure-dive-site/reviews/${reviewId}/report/`)
      .post({
        ...data,
      })
      .then(() => {
        toast.success(intl.formatMessage(messages.reportSent), {
          position: toast.POSITION.TOP_CENTER,
        })
      })
      .finally(() => {
        closeModal()
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      className='Modal react-popup form-popup reviews-modal'
      overlayClassName='Overlay'
      contentLabel='Review dive site popup'
    >
      <span className='close-btn' onClick={closeModal} />
      <Form
        onSubmit={handleReportSubmit}
        validate={addingReport}
        render={({ handleSubmit, submitting }) => (
          <form className='reviews-form' onSubmit={handleSubmit}>
            <FormTextArea
              className='reviews-form__block textarea'
              name='reason'
              label={intl.formatMessage(messages.report)}
              placeholder={intl.formatMessage(messages.placeholder)}
              rows='5'
              isRequired
            />
            <FormInput
              className='reviews-form__block'
              name='email'
              isRequired
              label={intl.formatMessage(messages.email)}
            />
            <button
              disabled={submitting}
              className='btn-guides-blue'
              type='submit'
            >
              <FormattedMessage defaultMessage='Send report' id='send_report' />
            </button>
          </form>
        )}
      />
    </Modal>
  )
}

export default injectIntl(ReviewReportModal)
